<template>
  <b-modal
    :id="`download-pdf-milestone`"
    :ref="`download-pdf-milestone`"
    hide-footer
    size="lg"
    centered
    content-class="rounded-8"
    @hide="clear"
  >
    <div class="mt-n5">
      <BlockHeader name="GENERATE PDF" />
      <div class="row">
        <div class="col-lg-4 col-sm-4 col-xs-4">
          <Select
            v-model="pdfLanguage"
            :options="languagesOptions"
            form-group-id="Language"
            placeholder="Language"
          />
        </div>
        <div class="col-lg-8 col-sm-8 col-xs-8 pt-1">
          <b-button
            v-if="downloading"
            variant="outline-primary"
            size="lg"
            class="px-4 mt-4"
            :disabled="!pdfLanguage || downloading"
            @click="downloadPDF"
          >
            {{ 'Generating' | i18n }}
            <b-spinner class="ml-1" small />
          </b-button>
          <b-button
            v-else
            variant="outline-primary"
            size="lg"
            class="px-4 mt-4"
            :disabled="!pdfLanguage || downloading"
            @click="downloadPDF"
          >
            {{ 'Download' | i18n }}
          </b-button>
          <b-button
            variant="primary"
            size="lg"
            class="ml-4 px-4 mt-4 line-height-28"
            @click="downloadOriginalPdf"
          >
            {{ 'Download original PDF' | i18n }}
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import axios from 'axios';

import Select from '../../../../common/select';
import BlockHeader from '../../../../common/block-header';
import { TRANSLATE_LANGUAGE } from '../../../../../../../../../constants';
import { AuthStorageMixin, NotificationMixin } from '../../../../../../mixins';

export default {
  name: 'DownloadPdfMilestoneModal',
  components: { Select, BlockHeader },
  mixins: [AuthStorageMixin, NotificationMixin],
  props: {
    milestoneId: {
      type: String,
      default: null,
    },
    milestoneName: {
      type: String,
      default: '',
    },
  },
  data: function () {
    return {
      downloading: false,
      pdfLanguage: '',
      languagesOptions: Object.keys(TRANSLATE_LANGUAGE).map((i) => ({ value: TRANSLATE_LANGUAGE[i], text: this.$translate(i) })),
    };
  },
  methods: {
    clear() {
      this.downloading = false;
      this.pdfLanguage = '';
    },
    async downloadPDF() {
      this.downloading = true;
      try {
        const baseUrl = axios.defaults.baseURL;
        const auth = this.authStorageService.getAuth();
        const token = auth.access_token_link;
        fetch(
          `${baseUrl}/api/v1/one/project-milestone/${this.milestoneId}/translate-pdf/${this.pdfLanguage}?authorization=${token}`
        )
          .then((resp) => resp.blob())
          .then((blob) => {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            a.download = `Milesone_${this.milestoneName.replace(/[^0-9a-zA-Z_ -]/g, '-').replace(/ /g, '_')}_${this.pdfLanguage}.pdf`;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            this.downloading = false;
            this.showNotification({ type: 'success', message: this.$translate('file_has_been_downloaded_successful') });
          })
          .catch((err) => {
            this.showNotification({ type: 'error', message: err.message });
            this.downloading = false;
          });
      } catch (err) {
        this.downloading = false;
        this.showNotification({ type: 'error', message: err.message });
      }
    },
    downloadOriginalPdf() {
      const baseUrl = axios.defaults.baseURL;
      const auth = this.authStorageService.getAuth();
      const token = auth.access_token_link;
      window.open(`${baseUrl}/api/v1/one/project-milestone/${this.milestoneId}/pdf?authorization=${token}`, '_blank');
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .modal-header {
  border: none;
  padding-bottom: 0px!important;
}

::v-deep .rounded-8 {
  border-radius: 8px;
}

::v-deep .btn-lg {
  font-size: 16px;
  line-height: 24px;
}

::v-deep .line-height-28 {
  line-height: 28px;
}
</style>